<template>
  <div class="app-landing">
    <div class="app-landing-wrap">
      <p class="intro-text">Rubies COVID Charity - Fund</p>
      <div class="d-none d-sm-block">
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-ico text-center">
                <span>
                  <img
                    src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/ico-1.png"
                    alt=""
                  />
                </span>
              </p>
              <p class="stat-title">Total Donations</p>
              <p class="stat-value">
                <span class="currency">₦</span>
                {{
                  donation.donationStats.totalDonationAmount
                    | newAmountFormatter
                }}
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-ico text-center">
                <span>
                  <img
                    src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/ico-2.png"
                    alt=""
                  />
                </span>
              </p>
              <p class="stat-title">Number of People</p>
              <p class="stat-value">
                {{ donation.donationStats.totalNumberOfDonations }}
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-ico text-center">
                <span>
                  <img
                    src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/ico-3.png"
                    alt=""
                  />
                </span>
              </p>
              <p class="stat-title">Number of Organisations</p>
              <p class="stat-value">
                {{ donation.donationStats.totalNumberOfOrganizations }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-8">
          <div class="landing-card">
            <p class="text-center">
              Currently, many Nigerians are negatively affected by the COVID-19
              pandemic. To support those who have been put into difficult
              economic situations, we have set up the Rubies COVID Charity Fund.
            </p>
            <div class="row">
              <div class="col-sm-6">
                <SocialShareModal />
              </div>
              <div class="col-sm-6">
                <DonateNowModal />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-block d-sm-none">
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-title">Total Donations</p>
              <p class="stat-value">
                <span class="currency">₦</span>
                {{ donation.donationStats.totalDonationAmount | moneyFormat }}
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-title">No. of People who donated</p>
              <p class="stat-value">
                {{ donation.donationStats.totalNumberOfDonations }}
              </p>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="stat-card">
              <p class="stat-title">No. Of Organization</p>
              <p class="stat-value">
                {{ donation.donationStats.totalNumberOfOrganizations }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SocialShareModal from "../Modal/SocialShareModal";
import DonateNowModal from "../Modal/DonateNowModal";
import { mapState } from "vuex";
export default {
  name: "AppLanding",
  components: { SocialShareModal, DonateNowModal },
  computed: {
    ...mapState(["donation"])
  }
};
</script>
